import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__add",
  "use": "general__add-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol stroke-linecap=\"round\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"general__add\">\n  <rect stroke=\"none\" width=\"16\" height=\"16\" rx=\"3\" fill=\"var(--color-button-disabled)\" />\n  <line x1=\"4\" y1=\"8\" x2=\"12\" y2=\"8\" stroke-width=\"1.5\" />\n  <line x1=\"8\" y1=\"4\" x2=\"8\" y2=\"12\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol